var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18998 2.03086C5.99037 1.46413 5.61979 0.973319 5.1294 0.626135C4.639 0.27895 4.05294 0.0925071 3.45209 0.0925293C1.84812 0.0925293 0.544586 1.39606 0.544586 3.00003C0.544586 4.604 1.84812 5.90753 3.45209 5.90753C4.05294 5.90755 4.639 5.72111 5.1294 5.37392C5.61979 5.02674 5.99037 4.53592 6.18998 3.9692H8.29792V5.90753H10.2363V3.9692H11.2054V2.03086H6.18998ZM3.45209 3.9692C2.91904 3.9692 2.48292 3.53307 2.48292 3.00003C2.48292 2.46699 2.91904 2.03086 3.45209 2.03086C3.98513 2.03086 4.42125 2.46699 4.42125 3.00003C4.42125 3.53307 3.98513 3.9692 3.45209 3.9692Z",
    fill: "#1EB4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.adf15d037a0e7482c53690cca529ad49.svg";
export { ForwardRef as ReactComponent };